module.exports = function () {
    var $heroWithClientStories = $('.hero-with-client-stories');

    if ($heroWithClientStories.length) {

        var $h1 = $(".hero-with-client-stories h1");

        $h1.html('<span>' + $h1.html().replace(/ /g, '</span> <span>') + '</span>');

        var adjustContentPositon = function () {
            $(".hero-with-client-stories-hero-headline").css("margin-top", "-" + $(".hero-with-client-stories-hero-subheader").outerHeight() / 2 + "px");
            var $lastSpan = $h1.find('span').last();
            $(".hero-with-client-stories-hero-link").css("left", $lastSpan.position().left + $lastSpan.outerWidth() - $(".hero-with-client-stories-hero-link").outerWidth() + "px");
        };
        adjustContentPositon();

        setTimeout(adjustContentPositon, 500);
        $(window).resize(adjustContentPositon);

        // initialize video modaal
        $('.hero-with-client-stories-video-modal-cta').modaal({
            type: 'video',
            overlay_opacity: 0.8,
            close_text: 'esc',
            custom_class: 'show-close-btn-text'
        });

        $('.hero-with-client-stories-video-modal-cta').click(function (e) {
            e.preventDefault();

            $(this).modaal('open');
        });

        $('.hero-with-client-stories.hero-with-client-stories--animate').addClass('hero-with-client-stories--is-animated');
    }
};